import { UserDetailRolesEnum } from 'generated/models/UserDetail';
import { UserType } from 'common/common.types';
import hasSome from './arrayHasSome';

export default (state: UserType, ...roles: UserDetailRolesEnum[]) =>
  hasSome(state.roles, ...roles);
